import type { ErrorCode } from "../lib/http/errors";
import type { Translate } from "./index";

/**
 * FE 코드 → 표시 방식 (SCR v0.6 FS-C1 · SRS 부록 B).
 *  - severity: 배너 색·role(err 만 role=alert)
 *  - studentSilent: 학생에게 아무것도 보이지 않는 코드(FE-305/306/402 — 서버 거부만)
 *  - studentToast: 학생에게는 피코 토스트로(FS-C1-07)
 */
export type Severity = "err" | "warn" | "info" | "ok";
export type Audience = "student" | "teacher";

interface FeMeta {
  severity: Severity;
  studentSilent?: boolean;
  studentToast?: boolean;
  /** 학생 배너 아이콘(SCR v0.6 FS-C1 와이어) — 없으면 심각도별 기본 */
  icon?: string;
}

export const FE_META: Record<ErrorCode, FeMeta> = {
  "FE-101": { severity: "warn" },
  "FE-102": { severity: "info" },
  "FE-103": { severity: "warn" },
  "FE-104": { severity: "warn" },
  "FE-201": { severity: "warn" },
  "FE-202": { severity: "warn", studentToast: true },
  "FE-203": { severity: "warn", studentToast: true },
  /** 스냅샷 프로그램 버전 불일치(SRS 부록 B · PRD 부록 C — 승인 2026-09-25) */
  "FE-204": { severity: "err" },
  "FE-301": { severity: "err", icon: "🔒" },
  "FE-302": { severity: "err", icon: "🔒" },
  "FE-303": { severity: "warn" },
  "FE-304": { severity: "info", icon: "🚪" },
  "FE-305": { severity: "warn", studentSilent: true },
  "FE-306": { severity: "warn", studentSilent: true },
  "FE-307": { severity: "info" },
  "FE-401": { severity: "info" },
  "FE-402": { severity: "err", studentSilent: true },
  "FE-501": { severity: "info" },
  "FE-502": { severity: "warn" },
  "FE-503": { severity: "info" },
  "FE-504": { severity: "info" },
  "FE-601": { severity: "warn", icon: "💻" },
  "NET-OFFLINE": { severity: "warn" },
  "NET-SERVER": { severity: "warn" },
};

export interface FeText {
  cause: string;
  next: string;
}

/** 역할별 FE 문구 — 학생 문구는 피코 어휘, 교사 문구는 코드 병기(SCR FS-C1). */
export function feText(t: Translate, code: ErrorCode, audience: Audience): FeText {
  return { cause: t(`fe.${code}.${audience}.cause`), next: t(`fe.${code}.${audience}.next`) };
}
